export const LINK_ACCOUNT_BTN = "Link Account";
export const LOGOUT_BTN_TEXT = "Already linked your account? Back to ";
export const LOGOUT_BTN_HREF_TEXT = "Login";
export const INVALID_TOKEN_TEXT = "Invalid Token";

export const linkAccountErrorMsgs = {
    PASSWORD_EMPTY: "Password cannot be empty.",
    PASSWORD_INCORRECT: "Incorrect password. Please try again.",
    REDIRECT_URL_MISSING: "An error occurs: Redirect URL is missing.",
};
